import { EffectCallback, useEffect, useRef } from 'react'

/**
 * Track the previous value of in an effect hook
 */
export const usePrevious = (value: any, initialValue: any) => {
  const ref = useRef(initialValue)
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

/**
 * Trace changed dependencies in an effect hook
 * @param effectHook The effect hook to trace
 * @param dependencies The dependencies to track
 * @param dependencyNames Optional names for the dependencies
 */
export const useEffectDebugger = (
  effectHook: EffectCallback,
  dependencies: any[],
  dependencyNames = [],
) => {
  const previousDeps = usePrevious(dependencies, [])

  const changedDeps = dependencies.reduce((accum, dependency, index) => {
    if (dependency !== previousDeps[index]) {
      const keyName = dependencyNames[index] || index
      return {
        ...accum,
        [keyName]: {
          before: previousDeps[index],
          after: dependency,
        },
      }
    }

    return accum
  }, {})

  if (Object.keys(changedDeps).length) {
    // eslint-disable-next-line no-console
    console.log('[use-effect-debugger] ', changedDeps)
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effectHook, dependencies)
}
